module.exports = __webpack_public_path__ + "static/media/couches-13.23689e14.jpg";